import React, { Component } from "react";
import {
  Col,
  Row,
  Nav,
  Card,
  Table,
  Form,
  Button,
  ButtonGroup,
  Breadcrumb,
  InputGroup,
  Dropdown,

} from "@themesberg/react-bootstrap";
import { FormGroup, CardHeader, Media, Input, Modal } from "reactstrap";
import Select from 'react-select';
import { faEnvelope, faPhone, faLock, faPencilAlt, faAddressCard, faUnlockAlt, faEyeSlash, faEye, faLocationArrow, faPiggyBank } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import SpinDiv from "../components/SpinDiv";
import { toast } from "react-toastify";
import axios from 'axios'
import settings from "../../services/settings";
import { authHeader } from "../../services/authHeader";
import { authService } from "../../services/authService";
import ReactDatetime from "react-datetime";
import moment from "moment"
import { editTrainer} from "../../services/trainerService";
import { getBranches } from "../../services/branchService";

export class EditTrainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
     
      show: false,
      edit: false,
      id: props.trainer.id,
      trainer: props.trainer,
      branches:[]

    };
  }

  componentDidMount() {
    toast.configure({ hideProgressBar: true, closeButton: false });
    this.getBranches();
  }


  getBranches = async () => {

    getBranches().then(

      (res) => {
        this.setState({
          branches: res.branches.data,
        });
      },
      (error) => {
        this.setState({ loading: false });
      }
    );
  };





  onSaveTrainer = async (e) => {
    e.preventDefault();
    await toast.dismiss();
    const { first_name, trainer, last_name, email, address, branch_id, validation } = this.state;
    console.log(trainer.branch_id);
    await this.setState({
      validation: {
        ...validation,
        email: trainer.email !== '' && trainer.email !== undefined,
        address: trainer.address !== '' && trainer.address !== undefined,
        branch: trainer.branch_id !== '' && trainer.branch_id !== undefined,
        first_name: trainer.first_name !== '' && trainer.first_name !== undefined,
        last_name: trainer.last_name !== '' && trainer.last_name !== undefined,
      },
    });
    if (Object.values(this.state.validation).every(Boolean)) {
      this.saveTrainer();
    } else {
      const errors = Object.keys(this.state.validation).filter((id) => {
        return !this.state.validation[id];
      });
      //await toast.configure({hideProgressBar: true, closeButton: false});
      toast.dismiss();
      toast.configure({ hideProgressBar: true, closeButton: false });

      toast(
        <div style={{ padding: "10px 20px" }}>
          <p style={{ margin: 0, fontWeight: "bold", color: "red" }}>Errors:</p>
          {errors.map((v) => (
            <p key={v} style={{ margin: 0, fontSize: 14, color: "red" }}>
              * {this.validationRules(v)}
            </p>
          ))}
        </div>
      )
    }
  };


  validationRules = (field) => {
    if (field === "first_name") {
      return "First Name  is required";
    } else if (field == 'last_name') {
      return "Last Name  is required"
    } else if (field == 'address') {
      return "Address is required"
    } else if (field == 'branch') {
      return "Branch is required"
    } else if (field == 'email') {
      return "Email is required"
    }
  };

 

  saveTrainer = () => {
    this.setState({ saving: true });
    const { trainer, id } = this.state;
    console.log();
    editTrainer({
      id: id,
      first_name: trainer.first_name,
      last_name: trainer.last_name,
      address: trainer.address,
      email: trainer.email,
      branch: trainer.branch_id,

    }).then(
      (res) => {
        console.log(res);
        this.setState({ loading: false });
        this.props.saved();
        this.props.toggle();
        this.showToast("Trainer has been updated");
      },
      (err) => {

        if (err) {
          toast.dismiss();
          toast.configure({ hideProgressBar: true, closeButton: false });
          if (err) {
            this.showToastError('An error occur, could not update Trainer')
          }
          this.setState({ saving: false });
        }
        this.setState({ loading: false });
      }
    );
  };

  

  showToast = msg => {
    toast(<div style={{ padding: 20, color: "green" }}>{msg}</div>);
  }
  showToastError = (msg) => {
    toast(<div style={{ padding: 20, color: "red" }}>{msg}</div>);
  };

  onChange = (e, state) => {
    const { trainer } = this.state

    this.setState({ trainer: { ...trainer, [state]: e } })
  }

  

  toggleEdit = () => {
    this.setState({ edit: !this.state.edit });
  };






  render() {

    const { toggle } = this.props;

    const { saving, edit, trainer,  branches, loading } = this.state;
    return (
      <>
        <Modal
          className="modal-dialog modal-dialog-top"
          isOpen={trainer != null}
          toggle={() => !loading && !saving && toggle}
        >
          {saving && <SpinDiv text={"Saving..."} />}
          {loading && <SpinDiv text={"loading..."} />}
          <div className="modal-header" style={{ padding: "1rem" }}>
            <div className="btn-toolbar mb-2 mb-md-0">
              <ButtonGroup>
                {trainer && (

                  <Button color={edit ? "secondary" : "success"}
                    onClick={this.toggleEdit}
                    size="sm" variant="outline-primary" size="sm">
                    {edit ? "Discard Changes" : "Edit trainer"}



                  </Button>
                )}
              </ButtonGroup>
            </div>

            <button
              type="button"
              className="btn-close"
              aria-label="Close"
              onClick={toggle}
            ></button>
          </div>
          <Card border="light" className="shadow-sm mb-4">
            <Card.Body className="pb-0">
              <Row>
                <Col md={12} style={{ border: '1px #eee solid', padding: '10px 5px 0px', margin: '0 2px', borderRadius: 7 }}>
                  <Form.Label style={{ paddingLeft: 10, fontSize: 18 }}>Trainer update <br/></Form.Label>
                  <Row style={{ border: '1px #eee solid', padding: '10px 5px 0px', margin: '0 2px', borderRadius: 7 }}>
                  <Row>
                <Col md={6}>
                  <Form.Group className="mb-2">
                    <Form.Label style={{ paddingRight: 10 }}>First Name</Form.Label>
                    <Input
                      className="custom-control-input"
                      id="reason"
                      disabled={!edit}
                      placeholder='Enter Trainers Address'
                      value={trainer.first_name}
                      onChange={async (e) => {
                        await this.onChange(e.target.value, "first_name");
                      }}
                      type="text"
                    />
                  </Form.Group>

                </Col>
                <Col md={6}>
                  <Form.Group className="mb-2">
                    <Form.Label style={{ paddingRight: 10 }}>Last Name</Form.Label>
                    <Input
                      className="custom-control-input"
                      id="last_name"
                      placeholder='Enter Last Name'
                      value={trainer.last_name}
                      disabled={!edit}
                      onChange={async (e) => {
                        await this.onChange(e.target.value, "last_name");
                      }}
                      type="text"
                    />
                  </Form.Group>

                </Col>
              </Row>
              <Row>
                <Col md={6}>
                  <Form.Group className="mb-2">
                    <Form.Label style={{ paddingRight: 10 }}>Email Address</Form.Label>
                    <Input
                      className="custom-control-input"
                      id="reason"
                      placeholder='Enter Email Address'
                      value={trainer.email}
                      onChange={async (e) => {
                        await this.onChange(e.target.value, "email");
                      }}
                      disabled={!edit}
                      type="text"
                    />
                  </Form.Group>

                </Col>
                <Col md={6} >
                  <Form.Group className="mb-2">
                    <Form.Label>Branches</Form.Label>

                    <Form.Select
                      id="state"
                      required
                      value={trainer.branch_id}
                      disabled={!edit}
                      onChange={async (e) => {
                        await this.onChange(e.target.value, "branch_id");
                      }}
                      disabled={!edit}
                      style={{
                        marginRight: 10,
                        width: "100%",
                      }}
                    >

                      <option value="">choose Branch</option>
                      {branches.length == 0 && <option value="">loading</option>}
                      {branches.map((p, index) => (
                        <option value={p.id} key={p}>
                          {p.name}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>

                </Col>
                <Col md="6">

                </Col>
              </Row>
              <Row>
                <Col md="12">

                </Col>
              </Row>
              <Row>
                <Col md={6} style={{ paddingTop: 15 }}>
                  <Form.Group className="mb-2">
                    <Form.Label style={{ paddingRight: 10 }}>Address</Form.Label>
                    <Input
                      className="custom-control-input"
                      id="reason"
                      placeholder='Enter Trainers Address'
                      value={trainer.address}
                      disabled={!edit}
                      onChange={async (e) => {
                        await this.onChange(e.target.value, "address");
                      }}
                      type="textarea"
                    />
                  </Form.Group>

                </Col>
                <Col md={6} style={{ paddingTop: 15 }}>
                  <Form.Group className="mb-2">
                    <Form.Label style={{ paddingRight: 10 }}>Expertise</Form.Label>
                    <Input
                      className="custom-control-input"
                      id="reason"
                      disabled={!edit}
                      placeholder='Expertise'
                      value={trainer.expertise}
                      onChange={async (e) => {
                        await this.onChange(e.target.value, "trainer.expertise");
                      }}
                      type="textarea"
                    />
                  </Form.Group>

                </Col>

              </Row>
              <Row>

              </Row>
              <Row style={{ marginTop: "10px" }}>
                <Col md={12}>
                  <div>
                    <Button
                      variant="primary"
                      size="sm"
                      style={{ marginTop: "10px", float: "right" }}
                      disabled={saving}
                      onClick={this.onSaveTrainer}
                    >
                      Save
                    </Button>
                    <Button
                      size="sm"
                      variant="transparent"
                      data-dismiss="modal"
                      type="button"
                      disabled={saving}
                      style={{ marginTop: "10px", float: "right" }}
                      onClick={toggle}
                    >
                      {" "}
                      Close
                    </Button>
                  </div>
                </Col>
              </Row>
                  
                  </Row>
                </Col>
              </Row>
            </Card.Body>
          </Card>
        </Modal>
      </>
    );
  }
}

export default EditTrainer;
